module.exports = __webpack_public_path__ + "img/wtb11.1c4de3e7.png";